import { AssistantClientEvent } from "@/api/model/Conversation";
import { useIsChatMutationPending } from "@/api/mutations/conversation";
import { FormattedMarkdown } from "@/components";
import { captureException } from "@/sentry";
import MessageSatisfaction from "../MessageSatisfaction";
import SmsHandoffSeed, { isSmsHandoffSeed } from "./SmsHandoffSeed";

interface OutputTextProps extends AssistantClientEvent {
  content: string;
  type: "output_text" | "refusal" | "subjective" | "sms_gated_content";
}

const OutputText = ({
  content,
  isLatest,
  messageId,
  maybeCopy,
  feedback,
  feedbackComment,
}: OutputTextProps) => {
  const isPending = useIsChatMutationPending();
  const showSatisfaction = (isLatest && !isPending) || !isLatest;

  if (typeof content !== "string") {
    captureException(
      "Unexpected content type found while rendering output text.",
      {
        extra: { content },
      },
    );
    return null;
  }

  if (isSmsHandoffSeed(content)) {
    return <SmsHandoffSeed content={content} />;
  }

  return (
    <>
      <FormattedMarkdown markdown={content} />
      {showSatisfaction && (
        <MessageSatisfaction
          messageId={messageId}
          feedback={feedback}
          feedbackComment={feedbackComment}
          onCopy={() => maybeCopy(content)}
        />
      )}
    </>
  );
};

export default OutputText;
